// Global Imports
import * as React from "react";
// Controls
import { IconIndicator } from "./IconIndicator";
// Style
import { useTheme } from "@fluentui/react";
import { appsSmallIconProps } from "../../../icons/icons.styles";
import { getBaseIndicatorStyles } from "./Indicators.styles";
// Utilities
import { Strings } from "@ms/uno-resources/lib/local/CultureUtilities";
/**
 * AppPoweredTask Indicator component that renders an icon indicating a checklist exists on the task
 */ export const AppPoweredTaskIndicator = (props)=>{
    const appPoweredTaskIndicatorAriaLabel = Strings.TaskEditor_AppPoweredTasksOpenTaskButtonAriaLabel;
    const theme = useTheme();
    const styles = getBaseIndicatorStyles(theme);
    return /*#__PURE__*/ React.createElement("div", {
        className: "appPoweredTask indicator",
        title: appPoweredTaskIndicatorAriaLabel
    }, /*#__PURE__*/ React.createElement(IconIndicator, {
        ...props,
        ariaLabel: appPoweredTaskIndicatorAriaLabel,
        iconProps: appsSmallIconProps,
        styles: styles
    }));
};
